import { render } from "./SpeakerTopic.vue?vue&type=template&id=3b44eed8&ts=true"
import script from "./SpeakerTopic.vue?vue&type=script&lang=ts"
export * from "./SpeakerTopic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__